// extracted by mini-css-extract-plugin
export default {"root":"Notifier_root__Rs44R","buttons":"Notifier_buttons__Jo89G","button":"Notifier_button__LNmNp","support":"Notifier_support__BJ7QB"};